import React from 'react';
import { Participant } from '../../types';

interface LiveLeaderboardBannerProps {
  participants: Participant[];
}

export const LiveLeaderboardBanner: React.FC<LiveLeaderboardBannerProps> = ({ participants }) => {
  const getInitials = (name: string) => {
    return name
      .split(' ')
      .map((word) => word.charAt(0).toUpperCase())
      .join('');
  };

  return (
    <div className="leaderboard-banner">
      <div className="banner-content">
        <h2>
          Live Leaderboard:
          <br />
          Top 3 Participants
        </h2>
        <p>
          See who's leading the challenge in real time! These rankings update live as participants
          make progress
        </p>
      </div>
      <div className="podium">
        {[2, 1, 3]
          .map((position) => participants.find((p) => p.position === position))
          .filter((participant): participant is Participant => participant !== undefined)
          .map((participant) => (
            <div key={participant.id} className={`podium-item position-${participant.position}`}>
              <div className="participant-info">
                <div className="avatar">{getInitials(participant.name)}</div>
                <span className="name">{participant.name}</span>
              </div>
              <div className="podium-bar">
                <span className="position-label">Top {participant.position}</span>
              </div>
            </div>
          ))}
      </div>
    </div>
  );
};
